import React, { useEffect, useMemo, useState } from 'react'

// Animation constants
const SPLASH_DURATION = 3500
const FADE_DELAY = 0.1
const FADE_DURATION = 1
const ROTATE_START_DELAY = 1

const ANIMATION_STYLES = `
  @keyframes fadeInScale {
    0% { opacity: 0; transform: scale(0); }
    100% { opacity: 1; transform: scale(1); }
  }
  @keyframes rotateWithPause {
    0% { transform: rotate(0deg); }
    50% { transform: rotate(360deg); }
    100% { transform: rotate(360deg); }
  }
`

export const SplashScreen = ({ shouldShow = null }) => {
  const [show, setShow] = useState(true)
  const [minDurationPassed, setMinDurationPassed] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMinDurationPassed(true)
      setShow(false)
    }, SPLASH_DURATION)
    return () => clearTimeout(timeout)
  }, [])

  // If shouldShow prop is provided, use it after minimum duration has passed
  const isVisible = shouldShow !== null && minDurationPassed ? shouldShow : show

  const containerStyle = useMemo(
    () => ({
      animation: `fadeInScale ${FADE_DURATION}s ease-out ${FADE_DELAY}s forwards`,
      opacity: 0,
      transform: 'scale(0)'
    }),
    []
  )

  const rotatingIconStyle = useMemo(
    () => ({
      animation: `rotateWithPause 1.5s linear ${ROTATE_START_DELAY}s infinite`
    }),
    []
  )

  if (!isVisible) return null

  return (
    <>
      <style>{ANIMATION_STYLES}</style>
      <div className="flex justify-content-center align-items-center vh-100 w-100 bg-surface position-fixed z-50">
        <div className="flex align-items-baseline gap-3" style={containerStyle}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={104}
            height={120}
            viewBox="0 0 104 120"
            fill="none"
            aria-label="Centrali Logo">
            <path
              d="M55.4901 120C22.212 120 0 95.7769 0 60C0 24.1434 22.0528 0 55.3309 0C76.1895 0 94.7393 10.996 103.258 29.0837L82.0808 40.5578C75.0749 28.5259 67.1932 23.745 55.5698 23.745C38.1345 23.745 26.7499 38.008 26.7499 60C26.7499 81.992 38.2938 96.255 55.729 96.255C67.5913 96.255 75.3934 90.757 82.0808 77.9283L103.417 89.243C93.3062 109.004 76.1895 120 55.4901 120Z"
              fill="var(--logo-color)"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={28}
            height={28}
            viewBox="0 0 28 28"
            fill="none"
            style={rotatingIconStyle}
            aria-label="Loading Indicator">
            <path d="M0 27.1713V0H27.2276V27.1713H0Z" fill="var(--color-secondary)" />
          </svg>
        </div>
      </div>
    </>
  )
}
